import React from "react"
import News from "../../../blocks/en/news_page"
import { Link, graphql } from "gatsby"

export const pageQuery = graphql`
query {
  news: newsYaml(slug: { eq: "poposki" }) {
    ...NewsInfoEn
  }
}`

export default class NewsTextEn extends News {
  renderNews() {
    return (
      <div className="row">
        <div className="col-xl-12">
          <p>A Macedonian coach of fitness and conditioning Sashko Poposki signed a new contract with the title holder of the Latvian top league - FC Riga. Poposki has joined the managerial team headed by Oleg Georgievich Kononov. We wish Poposki good luck in a new season!</p>
        </div>
      </div>
    )
  }
}